import loginActions from '../actionTypes/loginActions';

const getAction = (type, payload) => {
  return {
    type,
    payload
  };
};

export const setCurrentUser = payload => {
  return getAction(loginActions.setCurrentUser, payload);
};

export default getAction;
